import { LosslessNumber } from './LosslessNumber.js';
import { isInteger } from './utils.js';
export function parseLosslessNumber(value) {
  return new LosslessNumber(value);
}
export function parseNumberAndBigInt(value) {
  return isInteger(value) ? BigInt(value) : parseFloat(value);
}
//# sourceMappingURL=numberParsers.js.map